module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/wallet-3-4742ae0bd0dc0b233d8b0bf5faa539ab.svg";